export const RESET = 'EXCMNOTE_LIST_RESET'
export const SET_ITEMS = 'EXCMNOTE_LIST_SET_ITEMS'
export const SET_ERROR = 'EXCMNOTE_LIST_SET_ERROR'
export const SET_VIEW = 'EXCMNOTE_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXCMNOTE_LIST_TOGGLE_LOADING'
